import { ENDPOINT_BASE } from '@/config/endpoints'

export const ENDPOINT_WORKSPACE_SETTINGS = `${ENDPOINT_BASE}/e`
